var React = require('react');

function IconUnlimitedrewards (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"m39 23.8h50a0 0 0 0 1 0 0v19.4a25 25 0 0 1 -25 25 25 25 0 0 1 -25-25v-19.4a0 0 0 0 1 0 0z","key":0}),React.createElement("path",{"d":"m39 30h-16.64c0 24.59 18.92 23.65 18.92 23.65","key":1}),React.createElement("path",{"d":"m89.07 30h16.62c0 24.59-18.92 23.65-18.92 23.65","key":2}),React.createElement("path",{"d":"m38.98 97.96h50v8h-50z","key":3}),React.createElement("path",{"d":"m50.98 89.96h26v8h-26z","key":4}),React.createElement("path",{"d":"m69.87 67.5a58.75 58.75 0 0 0 6.26 20.89l.87 1.67h-26l.86-1.67a58.61 58.61 0 0 0 6.24-20.83","key":5}),React.createElement("path",{"d":"m63.98 32.39 3.86 7.45 8.43 1.48-6.04 5.87 1.34 8.58-7.59-4.03-7.6 4.03 1.34-8.58-6.03-5.87 8.42-1.48z","key":6})]);
}

IconUnlimitedrewards.defaultProps = {"viewBox":"0 0 128 128"};

module.exports = IconUnlimitedrewards;

IconUnlimitedrewards.default = IconUnlimitedrewards;
